export const EC_ACCOUNT_PLATFORMS = [
  { value: "Shopify", label: "Shopify" },
  { value: "Shopee", labelKey: "enums.ec_account.platform.Shopee" },
  { value: "Shopline", label: "Shopline" },
  { value: "Liteshop", label: "Liteshop" },
  { value: "NineOneApp", labelKey: "enums.ec_account.platform.NineOneApp" },
  { value: "Momo", label: "MOMO" },
  { value: "Woocommerce", label: "WooCommerce" },
  { value: "Cyberbiz", label: "Cyberbiz" },
  { value: "YahooScm", labelKey: "enums.ec_account.platform.YahooScm" },
  { value: "Pchome", label: "PChome" },
  { value: "MoPlus", labelKey: "enums.ec_account.platform.MoPlus" },
  { value: "EasyStore", label: "EasyStore" },
  { value: "BvShop", label: "BvShop" },
  { value: "Coupang", labelKey: "enums.ec_account.platform.Coupang" },
];

export const EC_ACCOUNT_PLATFORM_COLORS = {
  Shopee: "orange",
  Shopify: "green",
  Shopline: "blue",
  Yahoo: "purple",
  Momo: "red",
  Pchome: "cyan",
  EasyStore: "geekblue",
  Liteshop: "lime",
  LiteshopV2: "gold",
  Coupang: "volcano",
  Cyberbiz: "purple",
  NineOneApp: "blue",
  MoPlus: "gold",
  BvShop: "purple",
  Woocommerce: "geekblue",
};

export const buildEcAccountPlatformOptions = (t) =>
  EC_ACCOUNT_PLATFORMS.map(({ value, label, labelKey }) => ({
    value,
    label: labelKey ? t(labelKey) : label,
  }));

export const TIME_SLOTS = Array.from({ length: 48 }, (_, i) => {
  const hour = Math.floor(i / 2);
  const min = (i % 2) * 30;
  const value = hour * 100 + min;
  return {
    value,
    label: `${String(hour).padStart(2, "0")}:${String(min).padStart(2, "0")}`,
  };
});

export const PLATFORMS_WITH_SHIPPING_MAPPING = [
  "Liteshop",
  "Shopee",
  "NineOneApp",
  "Shopline",
  "Woocommerce",
  "Shopify",
  "Cyberbiz",
  "EasyStore",
  "BvShop",
  "Momo",
  "MoPlus",
];

// OAuth 授權模式的平台（不需要測試連線按鈕，授權成功即 connected）
export const OAUTH_PLATFORMS = ["Shopify", "Shopee", "Liteshop"];

export const PLATFORMS_WITHOUT_CUSTOM_SHIPPING_CODE = [
  "Shopee",
  "Momo",
  "MoPlus",
];

// 支援「貨主自備 Custom App」的平台 — 連線頁可填自己的 client id / secret
// 走 OAuth。需搭配 deployment flag support_custom_apps 才會顯示入口。
export const PLATFORMS_WITH_CUSTOM_APP_SUPPORT = ["Shopify"];

// 真正影響「連線驗證」的 credentials 欄位；其餘（如 Coupang 退貨地/發貨地代碼）
// 屬於後設定，使用者修改不應讓「測試連線」按鈕回到可點狀態
// 平台未列出時，fallback 比對全部 credentials 欄位
export const AUTH_CREDENTIAL_KEYS = {
  Coupang: ["vendor_id", "access_key", "secret_key"],
  // webhook_secret / webhook_subscriptions 由後端在連線成功時自動產生並寫入 credentials，
  // 非貨主填寫的連線驗證欄位 — 列出真正的 3 個 auth key，避免它們變動時重置「測試連線」。
  Woocommerce: ["api_domain", "api_username", "api_key"],
};

// 每個平台預計顯示的憑證欄位 (包含 Key 與 I18n Label Key)
export const PLATFORM_CREDENTIAL_FIELDS = {
  Shopify: [
    {
      key: "api_domain",
      labelKey: "models.ec_account.platform_settings.shopify.api_domain",
    },
  ],
  Shopee: [
    {
      key: "shop_id",
      labelKey: "models.ec_account.platform_settings.shopee.shop_id",
    },
  ],
  Shopline: [
    {
      key: "api_key",
      labelKey: "models.ec_account.platform_settings.shopline.api_key",
    },
  ],
  Liteshop: [
    {
      key: "shop_title",
      labelKey: "models.ec_account.platform_settings.liteshop.shop_title",
    },
  ],
  NineOneApp: [
    {
      key: "code",
      labelKey: "models.ec_account.platform_settings.nine_one_app.code",
    },
    {
      key: "api_key",
      labelKey: "models.ec_account.platform_settings.nine_one_app.api_key",
    },
    {
      key: "sender_name",
      labelKey: "models.ec_account.platform_settings.nine_one_app.sender_name",
    },
  ],
  Momo: [
    {
      key: "entp_id",
      labelKey: "models.ec_account.platform_settings.momo.entp_id",
    },
    {
      key: "entp_code",
      labelKey: "models.ec_account.platform_settings.momo.entp_code",
    },
    {
      key: "entp_pwd",
      labelKey: "models.ec_account.platform_settings.momo.entp_pwd",
    },
    {
      key: "otp_back_no",
      labelKey: "models.ec_account.platform_settings.momo.otp_back_no",
    },
    {
      key: "pdf_password",
      labelKey: "models.ec_account.platform_settings.momo.pdf_password",
    },
  ],
  Woocommerce: [
    {
      key: "api_domain",
      labelKey: "models.ec_account.platform_settings.woocommerce.api_domain",
    },
    {
      key: "api_username",
      labelKey: "models.ec_account.platform_settings.woocommerce.api_username",
    },
    {
      key: "api_key",
      labelKey: "models.ec_account.platform_settings.woocommerce.api_key",
    },
  ],
  Cyberbiz: [
    {
      key: "email",
      labelKey: "models.ec_account.platform_settings.cyberbiz.email",
    },
    {
      key: "access_token",
      labelKey: "models.ec_account.platform_settings.cyberbiz.access_token",
    },
    {
      key: "tcat_customer_code",
      labelKey: "models.ec_account.platform_settings.cyberbiz.tcat_customer_code",
    },
    {
      key: "ecan_customer_code",
      labelKey: "models.ec_account.platform_settings.cyberbiz.ecan_customer_code",
    },
  ],
  YahooScm: [
    {
      key: "token",
      labelKey: "models.ec_account.platform_settings.yahoo_scm.token",
    },
    {
      key: "key_iv",
      labelKey: "models.ec_account.platform_settings.yahoo_scm.key_iv",
    },
    {
      key: "key_value",
      labelKey: "models.ec_account.platform_settings.yahoo_scm.key_value",
    },
    {
      key: "salt_key",
      labelKey: "models.ec_account.platform_settings.yahoo_scm.salt_key",
    },
    {
      key: "version",
      labelKey: "models.ec_account.platform_settings.yahoo_scm.version",
    },
  ],
  Pchome: [
    {
      key: "vendor_id",
      labelKey: "models.ec_account.platform_settings.pchome.vendor_id",
    },
    {
      key: "aes_key",
      labelKey: "models.ec_account.platform_settings.pchome.aes_key",
    },
    {
      key: "aes_iv",
      labelKey: "models.ec_account.platform_settings.pchome.aes_iv",
    },
  ],
  MoPlus: [
    {
      key: "token",
      labelKey: "models.ec_account.platform_settings.mo_plus.token",
    },
    {
      key: "pdf_password",
      labelKey: "models.ec_account.platform_settings.mo_plus.pdf_password",
    },
  ],
  EasyStore: [
    {
      key: "api_domain",
      labelKey: "models.ec_account.platform_settings.easy_store.api_domain",
    },
    {
      key: "access_token",
      labelKey: "models.ec_account.platform_settings.easy_store.access_token",
    },
  ],
  BvShop: [
    {
      key: "api_domain",
      labelKey: "models.ec_account.platform_settings.bv_shop.api_domain",
    },
    {
      key: "access_token",
      labelKey: "models.ec_account.platform_settings.bv_shop.access_token",
    },
  ],
  Coupang: [
    {
      key: "vendor_id",
      labelKey: "models.ec_account.platform_settings.coupang.vendor_id",
    },
    {
      key: "access_key",
      labelKey: "models.ec_account.platform_settings.coupang.access_key",
    },
    {
      key: "secret_key",
      labelKey: "models.ec_account.platform_settings.coupang.secret_key",
    },
    {
      key: "return_center_code_seven",
      labelKey:
        "models.ec_account.platform_settings.coupang.return_center_seven",
    },
    {
      key: "return_center_display_text_seven",
      labelKey:
        "models.ec_account.platform_settings.coupang.return_center_seven_display_text",
    },
    {
      key: "return_center_code_family",
      labelKey:
        "models.ec_account.platform_settings.coupang.return_center_family",
    },
    {
      key: "return_center_display_text_family",
      labelKey:
        "models.ec_account.platform_settings.coupang.return_center_family_display_text",
    },
    {
      key: "outbound_shipping_place_code",
      labelKey:
        "models.ec_account.platform_settings.coupang.outbound_shipping_place",
    },
    {
      key: "outbound_shipping_place_display_text",
      labelKey:
        "models.ec_account.platform_settings.coupang.outbound_shipping_place_display_text",
    },
  ],
};

export const getPlatformCredentialFields = (moduleName) => {
  return PLATFORM_CREDENTIAL_FIELDS[moduleName] || [];
};

// 空值代碼（廠商配送）對應的 placeholder value，避免空字串無法當 Select option
export const EMPTY_SHIPPING_CODE_VALUE = "___EMPTY___";

// 各平台預設的物流代碼選項（label 同時用於 Edit 下拉與 Show 表格顯示）
export const PLATFORM_SHIPPING_CODES = {
  Liteshop: [
    { label: "宅配(regular)", value: "regular" },
    { label: "面交(person)", value: "person" },
    { label: "7-11超商取貨(cvs)", value: "cvs" },
    { label: "全家超商取貨(cvs_fami)", value: "cvs_fami" },
    { label: "郵寄(post)", value: "post" },
    { label: "國際運送(international)", value: "international" },
    { label: "冷凍(frozen)", value: "frozen" },
    { label: "低溫宅配(coldchain)", value: "coldchain" },
    { label: "即時物流(realtime)", value: "realtime" },
    { label: "指定配送地點(restricted)", value: "restricted" },
  ],
  Shopee: [
    {
      label: "賣家宅配：大型/超重物品運送",
      value: "賣家宅配：大型/超重物品運送",
    },
    { label: "賣家宅配：箱購", value: "賣家宅配：箱購" },
  ],
  Momo: [{ label: "廠商配送", value: EMPTY_SHIPPING_CODE_VALUE }],
  MoPlus: [{ label: "廠商配送", value: EMPTY_SHIPPING_CODE_VALUE }],
  // 代碼用 shipping_lines.method_id（穩定機器碼）。以下為 RY ECPay(綠界)外掛常見的
  // method_id；貨主若用其他外掛/自訂運送，可直接填自己的 method_id（支援自訂代碼）。
  Woocommerce: [
    { label: "綠界外掛 - 宅配-黑貓", value: "ry_ecpay_shipping_home_tcat" },
    { label: "綠界外掛 - 宅配-宅配通", value: "ry_ecpay_shipping_home_ecan" },
    { label: "綠界外掛 - 超商-7-11", value: "ry_ecpay_shipping_cvs_711" },
    { label: "綠界外掛 - 超商-全家", value: "ry_ecpay_shipping_cvs_family" },
    { label: "綠界外掛 - 超商-萊爾富", value: "ry_ecpay_shipping_cvs_hilife" },
  ],
};

export const getPlatformShippingCodes = (moduleName) => {
  if (moduleName === "momo") return PLATFORM_SHIPPING_CODES.Momo;
  return PLATFORM_SHIPPING_CODES[moduleName] || [];
};

// 將原始代碼轉成顯示 label：找不到時回傳原代碼
export const formatPlatformShippingCode = (code, moduleName) => {
  const codes = getPlatformShippingCodes(moduleName);
  const lookupValue = code === "" ? EMPTY_SHIPPING_CODE_VALUE : code;
  const found = codes.find((c) => c.value === lookupValue);
  return found ? found.label : code;
};
